import React, { useState } from 'react';
import { COUNTRIES } from '../../data/countries';
import { db } from '../../lib/supabase';

const PORTS = ['Alger','Bejaia','Oran','Annaba','Djendjen','Skikda','Mostaganem','Ghazaouet'];

export default function QuoteRequestForm({ lang, simulationData }) {
  const ar = lang === 'ar';
  const L = (fr, a) => ar ? a : fr;
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    product: simulationData?.description || '', hsCode: simulationData?.code_sh || '',
    country: simulationData?.pays || '', port: '', valueUsd: simulationData?.prix || '',
    weightKg: '', incoterm: simulationData?.incoterm || 'CIF', requirements: '',
    email: '', phone: '',
  });

  if (submitted) return (
    <div className="card" style={{ textAlign:'center', padding:'2rem' }}>
      <div style={{ fontSize:'2.5rem', marginBottom:'0.5rem' }}>✅</div>
      <h3 style={{ color:'#10b981' }}>{L('Demande envoyée !','تم إرسال الطلب!')}</h3>
      <p style={{ color:'var(--muted)', fontSize:'0.85rem' }}>{L('Vous recevrez les devis des transitaires rapidement.','ستتلقى عروض الأسعار من وكلاء الجمارك بسرعة.')}</p>
    </div>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.product || !form.country || !form.port || !form.email || !form.phone) {
      setError(L('Veuillez remplir tous les champs obligatoires.','يرجى ملء جميع الحقول الإلزامية.'));
      return;
    }
    setSending(true);
    try {
      const { error: dbErr } = await db.from('quote_requests').insert({
        product_description: form.product, hs_code: form.hsCode || null,
        origin_country: form.country, destination_port: form.port,
        estimated_value_usd: form.valueUsd ? parseFloat(form.valueUsd) : null,
        estimated_weight_kg: form.weightKg ? parseFloat(form.weightKg) : null,
        incoterm: form.incoterm || null, special_requirements: form.requirements || null,
        requester_email: form.email, requester_phone: form.phone,
        lead_id: null,
      });
      if (dbErr) { setError('Erreur: ' + dbErr.message); setSending(false); return; }
      setSending(false);
      setSubmitted(true);
    } catch (err) { setError('Erreur: ' + err.message); setSending(false); }
  };

  return (
    <div className="card">
      <div className="card-title">📋 {L('Demander des devis','طلب عروض أسعار')}</div>
      <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:'1rem' }}>{L('Recevez gratuitement des devis de transitaires spécialisés.','احصل مجاناً على عروض أسعار من وكلاء جمارك متخصصين.')}</p>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group"><label>{L('Votre email','بريدك الإلكتروني')} *</label><input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required placeholder="email@example.com" /></div>
          <div className="form-group"><label>{L('Votre téléphone','هاتفك')} *</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} required placeholder="0555 000 000" /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>{L('Produit','المنتج')} *</label><input value={form.product} onChange={e => setForm({...form, product: e.target.value})} required /></div>
          <div className="form-group"><label>{L('Code SH','رمز SH')}</label><input value={form.hsCode} onChange={e => setForm({...form, hsCode: e.target.value})} placeholder="8544.49.90.00" /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>{L('Pays fournisseur','بلد المورد')} *</label>
            <select value={form.country} onChange={e => setForm({...form, country: e.target.value})} required>
              <option value="">{L('— Sélectionner —','— اختر —')}</option>
              {COUNTRIES.map(c => <option key={c.code} value={c.code}>{ar ? c.ar : c.name}</option>)}
            </select>
          </div>
          <div className="form-group"><label>{L('Port d\'arrivée','ميناء الوصول')} *</label>
            <select value={form.port} onChange={e => setForm({...form, port: e.target.value})} required>
              <option value="">{L('— Sélectionner —','— اختر —')}</option>
              {PORTS.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>{L('Valeur estimée (USD)','القيمة التقديرية (USD)')}</label><input type="number" value={form.valueUsd} onChange={e => setForm({...form, valueUsd: e.target.value})} /></div>
          <div className="form-group"><label>{L('Poids estimé (kg)','الوزن التقديري (كغ)')}</label><input type="number" value={form.weightKg} onChange={e => setForm({...form, weightKg: e.target.value})} /></div>
        </div>
        <div className="form-group"><label>{L('Exigences particulières','متطلبات خاصة')}</label><input value={form.requirements} onChange={e => setForm({...form, requirements: e.target.value})} placeholder={L('Ex: EUR.1 requis, produit alimentaire...','مثال: EUR.1 مطلوب، منتج غذائي...')} /></div>
        <div className="alert alert-info" style={{ fontSize:'0.75rem', marginBottom:'0.8rem' }}><span>🔒</span><div>{L('Vos coordonnées ne seront visibles par les transitaires qu\'après utilisation de leurs crédits.','بياناتك لن تكون مرئية لوكلاء الجمارك إلا بعد استخدام رصيدهم.')}</div></div>
        {error && <div className="alert alert-danger" style={{ fontSize:'0.8rem', marginBottom:'0.5rem' }}>⚠️ {error}</div>}
        <button type="submit" className="btn btn-primary" style={{ width:'100%' }} disabled={sending}>
          {sending ? <><span className="spinner"/> {L('Envoi...','جاري الإرسال...')}</> : `📨 ${L('Envoyer la demande','إرسال الطلب')}`}
        </button>
      </form>
    </div>
  );
}
